import { useAttachment, usePlatformUpdate } from '@reapitform/hooks'
import { IDocumentDefault } from '../../types'

export const useDefaultsDocumentPost = () => {
  const { verifyFiles, isLoading: isProcessingAttachment } = useAttachment({
    errorMessage: 'Failed to upload new document',
  })
  const path: string = '/api/Organization/DefaultAttachment'

  const [addDocument, isLoading, returnData, isSuccess, isError] = usePlatformUpdate<
    Omit<IDocumentDefault, 'id' | 'lastUpdatedUTC'>,
    IDocumentDefault
  >({
    path: path,
    method: 'POST',
    headers: {},
    errorMessage: 'Failed to upload new document',
    successMessage: 'Document successfully uploaded',
  })

  const uploadDocument: typeof addDocument = async (params) => {
    await verifyFiles([params.defaultAttachmentFileID])
    return addDocument(params)
  }
  return { addDocument: uploadDocument, returnData, isLoading: isLoading || isProcessingAttachment, isSuccess, isError }
}
